<div>
  <ng-container #content></ng-container>
</div>

